export default __webpack_public_path__ + "static/media/paypal.b0145787.jpg";